export default "__VITE_ASSET__1855851f__"